import { render, staticRenderFns } from "./PreviewRentOrderFooter.vue?vue&type=template&id=bc133eb6&scoped=true"
import script from "./PreviewRentOrderFooter.vue?vue&type=script&lang=js"
export * from "./PreviewRentOrderFooter.vue?vue&type=script&lang=js"
import style0 from "./PreviewRentOrderFooter.vue?vue&type=style&index=0&id=bc133eb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc133eb6",
  null
  
)

export default component.exports